import { createGlobalStyle } from 'styled-components'
import colors from 'common-ui-components/src/vtj/theme/colors'
import media from 'common-ui-components/src/vtj/theme/media'
import {
  h1,
  h2,
  h3,
  h4,
  p,
  responsiveBaseTextSizes,
} from 'common-ui-components/src/vtj/theme/typography'
import variables from 'common-ui-components/src/vtj/theme/variables'
import fonts from 'common-ui-components/src/vtj/theme/fonts'

const reset = `
/* http://meyerweb.com/eric/tools/css/reset/
v2.0 | 20110126
License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
`

const oldBrowser = `
.oldBrowser {
  position: relative;
  display: block;
  padding: 24px;
  z-index: 11111;
  background: ${colors.pendingItemColor};
  color: #000000;
  ${media.mobileAndTablet} {
    margin-top: 60px;
  }
  .content {
    width: 580px;
    margin: auto;
  }
  li {
    margin: 15px 0;
  }
  a {
    color: #000000;
    text-decoration: underline;
  }
}
`

export const GlobalStyle = createGlobalStyle`
${reset}
${fonts.fontFaces}
${oldBrowser}
* {
  box-sizing: border-box;
}

html{
  ${responsiveBaseTextSizes}
}

body {
  background-color: ${colors.bodyColor};
  color: ${colors.textColor};
  line-height: ${variables.textLineHeight}em;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

button {
  font-size: 100%;
}

body, input, textarea, button, label {
  font-family: ${fonts.bodyFont};
}

section {
  padding: 8px 0;
}

h1 {
  ${h1}
}

h2 {
  ${h2}
}

h3 {
  ${h3}
}

h4 {
  ${h4}
}

p {
  ${p}
}

a {
  color: ${colors.linkColor};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:visited {
    color: ${colors.visitedLinkColor};
  }
}

small {
  font-size: 14px;
  line-height: 16px;
}

label {
  display: block;
  margin: 16px 0 8px 0;
}

input,
textarea {
  color: #000;
  background: #fff;
  border: 1px solid ${colors.inputBorder};
  border-radius: 2px;
  transition: all .2s ease;
  background-clip: padding-box;
  box-sizing: border-box;
  font-weight: 400;
  padding: 10px;
  padding: .625rem;
  line-height: 20px;
  line-height: 1.25rem;
  font-size: ${variables.fontSize}px;
  font-size: 1rem;
  text-transform: none;
  width: 100%;
  vertical-align: top;
  display: inline-block;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,.2) inset;
  ::placeholder {
    color: ${colors.placeholderColor};
  }
  &[disabled] {
    cursor: not-allowed;
  }
}

input:focus,
textarea:focus {
  border-color: ${colors.actionBlue};
  box-shadow: 0 0 3px 0 ${colors.actionBlue};
  outline: 0;
}

strong {
  font-family: ${fonts.semiBoldFont};
}

ol li,
ul li {
  line-height: 24px;
  margin: 4px 0;
  padding: 4px;
}
`
